//import { AxiosRequestConfig } from "axios";
import { instance } from "./axios";
// TODO Should use the token in the userData context
export const httpGet = async (requestPath, config) => {
    const axiosResponse = await instance.get(requestPath, {
        ...config,
    });
    return axiosResponse.data;
};
export const httpGetWithAuth = async (requestPath, config, userToken) => {
    const axiosResponse = await instance.get(requestPath, {
        headers: {
            Authorization: "Bearer " + userToken,
        },
        ...config,
    });
    return axiosResponse.data;
};
export const httpPost = async (requestPath, data, config, userToken) => {
    const axiosResponse = await instance.post(requestPath, data, {
        headers: {
            Authorization: "Bearer " + userToken,
        },
        ...config,
    });
    return axiosResponse.data;
};

export const httpPut = async (requestPath, data, config) => {
    const axiosResponse = await instance.put(requestPath, data, {
        headers: {
            Authorization: "Bearer null",
        },
        ...config,
    });
    return axiosResponse.data;
};

export const httpDelete = async (requestPath, config) => {
    const axiosResponse = await instance.delete(requestPath, {
        headers: {
            Authorization: "Bearer null",
        },
        ...config,
    });
    return axiosResponse.data;
};
export async function sendHttpReq(finalToken, apiURL) {
    var resJsonFinal = [];
    try {
        var tokenstr = finalToken;
        const headers = { "Content-Type": "application/json", Authorization: "Bearer " + tokenstr };
        if (tokenstr != null) {
            var tokenR = await fetch(apiURL, { headers });
            const resJson = await tokenR.json();
            resJsonFinal = JSON.parse(JSON.stringify(resJson));
        } else {
            resJsonFinal = [];
        }
    } catch (err) {
        resJsonFinal = [];
    }
    return resJsonFinal;
}
export async function sendHttpPost(finalToken, apiURL, JsonBody) {
    var resJsonFinal = [];
    try {
        var tokenstr = finalToken;
        const headers = { "Content-Type": "application/json", Authorization: "Bearer " + tokenstr };
        if (tokenstr != null) {
            var tokenR = await fetch(apiURL, { method: "POST", headers, body: JsonBody });
            const resJson = await tokenR.json();
            resJsonFinal = JSON.parse(JSON.stringify(resJson));
        } else {
            resJsonFinal = [];
        }
    } catch (err) {
        resJsonFinal = [];
    }
    return resJsonFinal;
}
// import axios from "axios";

export const getApi = async (endpoint, token, params = {}) => {
    try {
        const response = await instance.get(`${endpoint}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: params,
        });
        return { data: response.data || response, error: null };
    } catch (error) {
        console.error("Error in getApi:", error);
        return { data: null, error };
    }
};

export const putApi = async (endpoint, data, token, isFormData = false) => {
    try {
        const headers = {
            Authorization: `Bearer ${token}`,
        };

        if (isFormData) {
            headers["Content-Type"] = "multipart/form-data";
        }

        const response = await instance.put(`${endpoint}`, data, {
            headers: headers,
        });

        return { data: response.data, error: null };
    } catch (error) {
        console.error("Error in putApi:", error);
        return { data: null, error };
    }
};

export const postApi = async (path, data, isFormData = false) => {
    const accessToken = localStorage.getItem("authUser");
    const token = accessToken.replace(/^"|"$/g, "");
    try {
        const response = await instance.post(path, data, {
            headers: {
                "Content-Type": isFormData ? "multipart/form-data" : "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return { response: response.data };
    } catch (error) {
        if (error.response && error.response.status === 401) {
            history.push("/login");
        }
        return { error };
    }
};
